import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { Timestamp } from "firebase/firestore";
import {
  Button,
  Container,
  InputGroup,
  Form,
  Row,
  Col,
  Modal,
  Table,
} from "react-bootstrap";
import {
  documentToPackaging,
  getPackaging,
  Packaging,
  savePackaging,
  loadHistoryMap,
  recordHistory,
  getDocData,
} from '../data/PackagingData';
import { getReferenceName } from '../utils/ReferendeUtils';
import ToggleButton from 'react-toggle-button';


export class PackagingForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      packaging: new Packaging(),
      docs: [],
      validated: false,
      isOpen: false,
      modalString: "",
      history: new Array(),
      historyMap: new Map(),
      dataLoading: true,
    };

    this.changeValue = this.changeValue.bind(this);
    this.COLLECTION = "packaging";
  }

  handleClose = () => this.setState({ isOpen: false });

  async getDocumentFromDB() {
    try {
      let existingPackagingDoc = await getPackaging(this.props.docRef);

      let newHistoryMap = new Map();
      if (existingPackagingDoc.data().history && existingPackagingDoc.data().history.length !== 0) {
        newHistoryMap = await loadHistoryMap(existingPackagingDoc.data().history);
      }
      let existingPackaging = documentToPackaging(existingPackagingDoc);

      this.setState({
        packaging: existingPackaging,
        historyMap: newHistoryMap
      });
    } catch (e) {
      console.log("Error getting document ref:" + this.props.docRef);
    }

    this.setState({
      dataLoading: false,
    })


  }

  componentDidMount() {
    if (this.props.docRef !== '') {
      this.getDocumentFromDB();
    } else {
      this.setState({
        dataLoading: false,
      })
    }
  }
  handleStoreLookup = async (store) => {
    let searchString = "";
    if (this.state.packaging.description) {
      searchString = encodeURIComponent(this.state.packaging.description);
    }
    let url = ""
    switch (store) {
      case 'king_soopers':
        //https://www.kingsoopers.com/search?query=vanilla%20extract&searchType=default_search&fulfillment=ais
        url = 'https://www.kingsoopers.com/search?query=' + searchString + '&searchType=default_search&fulfillment=ais';
        break;
      case "walmart":
        //https://www.walmart.com/search?q=almond+milk&typeahead=almont&facet=fulfillment_method_in_store%3AIn-store
        url = 'https://www.walmart.com/search?q=' + searchString + '&typeahead=almont&facet=fulfillment_method_in_store%3AIn-store';
        break;
      case "sams":
        //https://www.samsclub.com/s/almond%20milk?selectedFilter=club
        url = 'https://www.samsclub.com/s/' + searchString + '?selectedFilter=club';
        break;
      case "natural_grocers":
        //https://www.naturalgrocers.com/product-finder?field_location=0&field_distance_to_search=60&sort_by=nid&sort_order=DESC&search_api_fulltext=almond+milk
        url = 'https://www.naturalgrocers.com/product-finder?field_location=0&field_distance_to_search=60&sort_by=nid&sort_order=DESC&search_api_fulltext=' + searchString;
        break;
      case "costco":
        //https://www.costco.com/s?keyword=almond+milk&refine=item_program_eligibility-InWarehouse%257C%257Citem_location_availability-in%2520stock
        url = 'https://www.costco.com/s?keyword=' + searchString + '&refine=item_program_eligibility-InWarehouse%257C%257Citem_location_availability-in%2520stock';
        break;
      case "amazon":
        //https://www.amazon.com/s?k=flour
        url = 'https://www.amazon.com/s?k=' + searchString
        break;
      case "azure_standard":
        //https://www.azurestandard.com/shop/search/millet%20flour
        url = 'https://www.azurestandard.com/shop/search/' + searchString
        break;
      default:
        break;
    }

    window.open(url, '_blank');
  }

  changeValue(event) {
    if (event.target.id === 'description') {
      let tempPacking = this.state.packaging;
      tempPacking.description = event.target.value;
      this.setState({ packaging: tempPacking });
    } else if (event.target.id === 'cost') {
      let tempPacking = this.state.packaging;
      tempPacking.cost = event.target.value;
      this.setState({ packaging: tempPacking });
    } else if (event.target.id === 'perselect') {
      let tempPacking = this.state.packaging;
      tempPacking.per = event.target.value;
      this.setState({ packaging: tempPacking });
    } else if (event.target.id === 'totalprice') {
      let tempPacking = this.state.packaging;
      if (event.target.value !== ''
        && this.state.total_quantity !== ''
        && typeof parseFloat(event.target.value) == 'number'
        && typeof parseInt(tempPacking.total_quantity) == 'number'
        && parseInt(tempPacking.total_quantity) !== 0) {
        let cost = Math.round(parseFloat(event.target.value) / parseInt(tempPacking.total_quantity) * 100) / 100;
        tempPacking.cost = cost;
      }
      tempPacking.total_price = event.target.value;
      this.setState({ packaging: tempPacking });
    } else if (event.target.id === 'totalqty') {
      let tempPacking = this.state.packaging;
      if (event.target.value !== ''
        && this.state.total_price !== ''
        && typeof parseFloat(event.target.value) == 'number'
        && typeof parseInt(tempPacking.total_price) == 'number'
        && parseInt(tempPacking.total_quantity) !== 0) {
        let cost = Math.round(parseFloat(tempPacking.total_price) / parseInt(event.target.value) * 100) / 100;
        this.setState({ cost: cost });
        tempPacking.cost = cost;
      }
      tempPacking.total_quantity = event.target.value;
      this.setState({ packaging: tempPacking });
    } else if (event.target.id === 'information') {
      let tempPacking = this.state.packaging;
      tempPacking.information = event.target.value;
      this.setState({ packaging: tempPacking });
    }
  }

  saveChangedPackaging = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ validated: true });
      return;
    }


    let documentName = '';
    if (this.props.docRef === '') {
      documentName = getReferenceName(this.state.packaging.description);
    } else {
      documentName = this.props.docRef;
    }

    let newHistoryList = new Array();
    let now = Timestamp.now();

    let cost_changed = false;
    let packaging = this.state.packaging;
    if (this.props.mode === 'Edit') {
      if (this.state.packaging.history && packaging.history.length !== 0) {
        newHistoryList = packaging.history;
      }

      cost_changed = await recordHistory(newHistoryList, now, packaging, documentName);
      packaging.history = newHistoryList;
    }

    let docData = getDocData(packaging);

    savePackaging(documentName, docData, cost_changed);

    this.setState({
      packaging: new Packaging(),
      validated: false,
      isOpen: true,
      modalString: "Packaging added!",
    });
    /**
     * toggle the show form so the add/edit is not shown.
     */
    this.props.toggleForm();
  }
  renderHistoryTableRow = (historyDocRef, historyRecord) => {
    let updatedDate = historyRecord.updateDate.toDate().toString();
    return (
      <tr>
        <td>{updatedDate}</td>
        <td>{historyRecord.field}</td>
        <td>{historyRecord.oldValue}</td>
        <td>{historyRecord.newValue}</td>
      </tr>
    );
  }

  render() {
    let historyMap = this.state.historyMap;
    let lastUpdatedString = "";
    if (this.state.packaging.last_updated) {
      lastUpdatedString = this.state.packaging.last_updated.toDate().toString();
    }
    return (
      <>
        {
          /* 
          * Packaging Add
          */
        }
        <Container fluid>
          <Modal show={this.state.isOpen} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Packaging</Modal.Title>
            </Modal.Header>
            <Modal.Body>Packaging Added!</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <h1>{this.props.mode} Packaging</h1>
          <h3>Store Lookups:</h3>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("king_soopers") }}
          >King Soopers</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("walmart") }}
          >WalMart</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("sams") }}
          >Sams</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("natural_grocers") }}
          >Natural Grocers</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("costco") }}
          >Costco</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("amazon") }}
          >Amazon</Button>
          <Button className="buttons"
            variant="dark"
            size="sm"
            onClick={() => { this.handleStoreLookup("azure_standard") }}
          >Azure Standard
          </Button>
          <Row>
            <Form.Label htmlFor="is_deleted">Deleted?:</Form.Label>
            <ToggleButton
              inactiveLabel={'No'}
              activeLabel={'Yes'}
              value={this.state.packaging.is_deleted}
              onToggle={(value) => {
                let tempPackaging = this.state.packaging;
                tempPackaging.is_deleted = !tempPackaging.is_deleted;
                this.setState({
                  packaging: tempPackaging,
                })
              }} />
          </Row>
          <Form noValidate validated={this.state.validated} onSubmit={this.saveChangedPackaging}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="description">Description:</Form.Label>
              <Form.Control
                required
                value={this.state.packaging.description}
                placeholder="Description"
                id="description"
                onChange={this.changeValue}
              />
            </Form.Group>
            <Row>
              <Col>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="totalprice">Total Purchase Price:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      required
                      value={this.state.packaging.total_price}
                      aria-label="totalprice"
                      placeholder="0.00"
                      id="totalprice"
                      onChange={this.changeValue}
                    />
                  </InputGroup>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="totalqty">Total Purchased Quantity:</Form.Label>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Control
                      required
                      value={this.state.packaging.total_quantity}
                      placeholder="0"
                      id="totalqty"
                      onChange={this.changeValue}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="perselect">Per:</Form.Label>
                  <Form.Group as={Col}>
                    <Form.Select
                      required
                      value={this.state.packaging.per}
                      id="perselect"
                      aria-label="Default select example"
                      onChange={this.changeValue}
                    >
                      <option></option>
                      <option value="cup">1 cup</option>
                      <option value="teaspoon">1 teaspoon</option>
                      <option value="tablespoon">1 tablespoon</option>
                      <option value="ounce">1 ounce</option>
                      <option value="piece">1 piece</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </Col>
              <Col>
                <Row className="mb-3">
                  <Form.Label as={Col} htmlFor="cost">Cost:</Form.Label>
                  <InputGroup as={Col} className="mb-3">
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      value={this.state.packaging.cost}
                      aria-label="Cost"
                      placeholder="0.00"
                      id="cost"
                      //onChange={this.changeValue}
                      disabled
                    />
                  </InputGroup>
                </Row>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="info">Information:</Form.Label>
              <Form.Control
                value={this.state.packaging.information}
                as="textarea"
                id="information"
                onChange={this.changeValue}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="lastupdated">Last Updated:</Form.Label>
              <Form.Control
                value={lastUpdatedString}
                id="lastupdated"
                disabled
              />
            </Form.Group>
            <Button variant="dark" onClick={() => { this.props.toggleForm() }}>
              Cancel
            </Button>{' '}
            <Button variant="dark" type="submit">
              Save
            </Button>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="history">History:</Form.Label>
              <Table
                disabled
                id="history"
                bordered>
                <thead>
                  <tr>
                    <th>Update Date</th>
                    <th>Field</th>
                    <th>Old Value</th>
                    <th>New Value</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...historyMap].map(([key, value]) => {
                      return this.renderHistoryTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </Form.Group>
          </Form>
        </Container>
      </>
    );

  }
}
